import { Breadcrumb, Col, Row, Container, Card, Button } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import careersImg from "../assets/images/33.jpg";
import "./Careers.css";

function Careers() {
  const navigate = useNavigate();

  return (
    <>
      <div className="careers-page">
        <div style={{}}>
          <Header />
        </div>

        {/* Banner */}
        <div className="careers-banner">
          <Container>
            <Row className="align-items-center g-5">
              {/* LEFT */}
              <Col lg={6} md={12}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="banner-content-careers"
                >
                  {/* <div className="careers-badge">Join Our Team</div> */}

                  <h1 className="careers-title-page">
                    Build Your Career With Us
                  </h1>

                  <p className="careers-text-page">
                    Explore exciting opportunities and grow your career in a
                    dynamic, innovative environment where your skills and
                    passion matter.
                  </p>

                  <Button
                    className="about-v2-btn mt-3"
                    onClick={() => navigate("/contact")}
                  >
                    Apply Now
                  </Button>

                  {/* <div className="mt-4">
            <Breadcrumb className="breadcrumb-careers">
              <Breadcrumb.Item
                className="breadcrumb-item-careers"
                onClick={() => navigate("/")}
              >
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                className="breadcrumb-item-careers"
                active
              >
                Careers
              </Breadcrumb.Item>
            </Breadcrumb>
          </div> */}
                </motion.div>
              </Col>

              {/* RIGHT IMAGE */}
              <Col lg={6} md={12} className="text-lg-end">
                <motion.img
                  src={careersImg}
                  alt="Careers"
                  className="careers-hero-image"
                  initial={{ opacity: 0, x: 40 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                />
              </Col>
            </Row>
          </Container>
        </div>

        {/* Top Section - White Background */}
        <Container className="careers-content-section">
          <motion.div
            className="careers-top-section-page"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="careers-main-title-page">
              Build the Future With Lyra Infotech
            </h2>
            <p className="careers-intro-text-page">
              At Lyra Infotech, we engineer scalable digital products built for
              global reach and long-term impact. Join a team that goes beyond
              features to architect platforms that shape how people experience
              technology.
            </p>
            <h3 className="careers-subtitle-page">
              We hire character. Train skill.
            </h3>
            <a
              href="mailto:info@lyrainfotech.com"
              className="careers-hiring-link-page"
            >
              Explore Opportunities
            </a>
          </motion.div>

          {/* Middle Section - Muted Blue Background */}
          <motion.div
            className="careers-middle-section-page"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            <h2 className="careers-section-title-page">
              We Build Careers That Scale — Just Like Our Products
            </h2>
            <p className="careers-description-text-page">
              Lyra Infotech is building a billion-user digital ecosystem across
              mobile and web platforms. We value ambition, ownership, and
              long-term thinking, driven by a product-first mindset, global
              scalability, and continuous innovation. If you want to build
              products that impact users worldwide — not just projects — this is
              your platform.
            </p>
            <div className="careers-buttons-page">
              <Button
                className="careers-btn-primary-page"
                onClick={() =>
                  window.scrollTo({
                    top:
                      document.getElementById("job-listings")?.offsetTop || 0,
                    behavior: "smooth",
                  })
                }
              >
                View Open Roles
              </Button>
              <Button
                className="careers-btn-secondary-page"
                onClick={() =>
                  window.scrollTo({
                    top:
                      document.getElementById("internship-section")
                        ?.offsetTop || 0,
                    behavior: "smooth",
                  })
                }
              >
                Apply For Internship
              </Button>
            </div>
          </motion.div>

          {/* Job Listings Section */}
          <div id="job-listings" className="job-listings-section">
            <h2 className="section-title-careers">Current Openings</h2>
            <Row>
              {[
                {
                  title: "Senior Web Developer",
                  department: "Development",
                  location: "Surat, Gujarat",
                },
                {
                  title: "Mobile App Developer",
                  department: "Development",
                  location: "Surat, Gujarat",
                },
                {
                  title: "UI/UX Designer",
                  department: "Design",
                  location: "Surat, Gujarat",
                },
                {
                  title: "React.js Developer",
                  department: "Development",
                  location: "Surat, Gujarat",
                },
                {
                  title: "Node.js Developer",
                  department: "Development",
                  location: "Surat, Gujarat",
                },
                {
                  title: "Digital Marketing Specialist",
                  department: "Marketing",
                  location: "Surat, Gujarat",
                },
              ].map((job, index) => (
                <Col lg={6} md={6} sm={12} key={index} className="mb-4">
                  <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1, duration: 0.6 }}
                  >
                    <Card className="job-card">
                      <Card.Body>
                        <h4 className="job-title">{job.title}</h4>
                        <p className="job-department">{job.department}</p>
                        <p className="job-location">{job.location}</p>
                        <Button
                          className="job-apply-btn"
                          onClick={() => navigate("/contact")}
                        >
                          Apply Now
                        </Button>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </div>

          {/* Internship Section */}
          <div id="internship-section" className="internship-section-page">
            <h2 className="section-title-careers">Internship Opportunities</h2>
            <p className="internship-description">
              Looking to kickstart your career? Join our internship program and
              gain hands-on experience working on real projects with our expert
              team.
            </p>
            <Button
              className="internship-apply-btn"
              onClick={() => navigate("/contact")}
            >
              Apply For Internship
            </Button>
          </div>

          {/* Bottom Section - Lighter Muted Blue Background */}
          <motion.div
            className="careers-bottom-section-page"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            <p className="careers-question-page">Can't Find the Right Role?</p>
            <a
              href="mailto:info@lyrainfotech.com"
              className="careers-email-link-page"
            >
              Send your resume to{" "}
              <strong>
                {" "}
                <b>info@lyrainfotech.com</b>
              </strong>
            </a>
          </motion.div>
        </Container>

        <Footer />
      </div>
    </>
  );
}

export default Careers;
